<p class="notice">{{text}}</p>
<div style="opacity: .1; width: 60%; margin: 0 auto;">
	<mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
